/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type ContentStackPostReviewer } from '@/features/contentstack/interface/content-types';
import styles from './BlogReviewer.module.scss';
import { View, Text } from '@az/starc-ui';
import { SmartLink as Link } from '@/utils/smartLink';
import { type ContentStackBlogPostSummary } from '@/features/contentstack/interface';
import dayjs from '@/lib/dayjs';
import cx from 'classnames';

export type BlogReviewerProps = {
  blogReviewer: Pick<ContentStackPostReviewer, 'title' | 'post_review' | 'url'>;
  date: ContentStackBlogPostSummary['reviewed_date'];
  verticalPadding?: boolean;
};

export const BlogReviewer = ({ blogReviewer, date, verticalPadding }: BlogReviewerProps) => {
  const parsedDate = date ? dayjs(date) : null;
  const formattedDate = parsedDate?.isValid() ? parsedDate.format('MMM DD YYYY') : '';
  const { url } = blogReviewer;
  return (
    <View className={styles.blogReviewer}>
      <Text
        variant="main-body"
        color="secondary"
        className={cx(styles.reviewerText, { [styles.withVerticalPadding]: verticalPadding })}
      >
        {blogReviewer.post_review.reviewed_by_text}{' '}
        <Link to={url}>{blogReviewer.post_review.reviewer_name}</Link>
      </Text>
      {formattedDate && (
        <Text attributes={{ 'data-testid': 'reviewed-date' }} className={styles.withDate}>
          {` ${formattedDate}`}
        </Text>
      )}
    </View>
  );
};
